export default __webpack_public_path__ + "static/media/Tiger's Jerkin of the Yellow Spring.874fe69a.jpg";